
export const setBreachesList = (items) => (dispatch, getState) => {

    // // 1.setting active item with the first item in the passed items
    // let activeItemId = '';
    // if (items.length > 0) {
    //     if (items[0].items) activeItemId = items[0].items[0]._id //items are grouped by date
    //     else activeItemId = items[0]._id //items are grouped by related threats
    // }
    // dispatch({
    //     type: 'SET_BREACHES_SECTION_ACTIVE_ITEM',
    //     payload: activeItemId
    // })

    //2. setting the items
    dispatch({
        type: 'SET_BREACHES_LIST',
        payload: items
    })
}

export const loadMoreBreaches = (items) => {
    return {
        type: 'LOAD_MORE_BREACHES',
        payload: items
    }
}

export const setBreachesSectionActiveItem = (itemId) => {
    return {
        type: 'SET_BREACHES_SECTION_ACTIVE_ITEM',
        payload: itemId
    }
}

export const breachesListNextItem = () => (dispatch, getState) => {

    const items = getState().dashboard_breachesList;
    const breachesListSortBy = getState().dashboard_breachesListSortBy;
    //creating array of ids
    let ids = [];
    if (breachesListSortBy === 'Date' && items.length > 0) {
        items.forEach(el => {
            if (el.items) ids = [...ids, ...el.items.map(item => item._id)]
        });
    } else ids = items.map(el => el._id)
    //finding the index of the current item in the ids array
    const currentIndex = ids.findIndex(id => id === getState().dashboard_breachesSectionActiveItem);
    const newItemId = ids[currentIndex + 1];
    dispatch({
        type: 'SET_BREACHES_SECTION_ACTIVE_ITEM',
        payload: newItemId
    })
}

export const breachesListPrevItem = () => (dispatch, getState) => {

    const items = getState().dashboard_breachesList;
    const breachesListSortBy = getState().dashboard_breachesListSortBy;
    //creating array of ids
    let ids = [];
    if (breachesListSortBy === 'Date' && items.length > 0) {
        items.forEach(el => {
            if (el.items) ids = [...ids, ...el.items.map(item => item._id)]
        });
    } else ids = items.map(el => el._id)
    //finding the index of the current item in the ids array
    const currentIndex = ids.findIndex(id => id === getState().dashboard_breachesSectionActiveItem);
    const newItemId = ids[currentIndex - 1];
    dispatch({
        type: 'SET_BREACHES_SECTION_ACTIVE_ITEM',
        payload: newItemId
    })
}

export const setBreachesListTotalCount = (count) => {
    return {
        type: 'SET_BREACHES_LIST_TOTAL_COUNT',
        payload: count
    }
}

export const setBreachesListSortBy = (sortBy) => (dispatch) => {

    dispatch({ type: 'RESET_BREACHES_SECTION_PAGE' });
    dispatch({
        type: 'SET_BREACHES_LIST_SORT_BY',
        payload: sortBy
    })
}

export const setBreachesListSortOrder = (sortOrder) => (dispatch) => {

    dispatch({ type: 'RESET_BREACHES_SECTION_PAGE' });
    dispatch({
        type: 'SET_BREACHES_LIST_SORT_ORDER',
        payload: sortOrder
    })
}

export const setBreachesListPage = (page) => {
    return {
        type: 'SET_BREACHES_LIST_PAGE',
        payload: page
    }
}

export const setBreachItemCheck = (check) => {
    return {
        type: 'SET_CHECK_BREACH_ITEM',
        payload: check
    }
}